import { Link, createSearchParams } from 'react-router-dom';
import css from './selected-materials.module.scss';
import classNames from 'classnames';
import { GLOBAL_SEARCH } from 'src/constants/routes';
import { ReactComponent as LinkArrow } from 'src/assets/services-arrow-btn-2.svg';

export default function SelectedMaterials() {
  return (
    <div className={css.selectedMaterials}>
      <div className={css.container}>
        <div className={classNames(css.card, css.military)}>
          <div className={css.container}>
            <div className={css.cardText}>
              <LinkArrow className={css.arrow} />
              <Link
                to={{
                  pathname: GLOBAL_SEARCH.path,
                  search: createSearchParams({
                    search: 'Військовослужбовцям'
                  }).toString()
                }}>
                Військовослужбовцям
              </Link>
            </div>
          </div>
        </div>
        <div className={classNames(css.card, css.family)}>
          <div className={css.container}>
            <div className={css.cardText}>
              <LinkArrow className={css.arrow} />
              <Link
                to={{
                  pathname: GLOBAL_SEARCH.path,
                  search: createSearchParams({
                    search: 'Родинам'
                  }).toString()
                }}>
                Родинам
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
